(() => {
  if (window.tiarooCartProgressReady) return;
  window.tiarooCartProgressReady = true;
  const getPanel = element => element?.closest('cart-drawer, .cart__footer, main')?.querySelector('.tiaroo-cart-progress') || document.querySelector('.tiaroo-cart-progress');
  function showMinimum(element) {
    const panel = getPanel(element);
    if (!panel || Number(panel.dataset.cartTotal) >= 3000) return false;
    const amount = (3000 - Number(panel.dataset.cartTotal)) / 100;
    const message = panel.querySelector('.tcp-error');
    if (message) {
      message.hidden = false;
      message.textContent = `Your cart needs US$${amount.toFixed(2)} more to reach the US$30 minimum. Add another little favourite to unlock checkout.`;
    }
    panel.classList.remove('tcp-attention');
    requestAnimationFrame(() => panel.classList.add('tcp-attention'));
    panel.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'nearest'});
    return true;
  }
  document.addEventListener('click', event => {
    const button = event.target.closest('button[name="checkout"], input[name="checkout"], a[href="/checkout"]');
    if (button && showMinimum(button)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!form.matches('form[action$="/cart"]')) return;
    if (event.submitter && event.submitter.name !== 'checkout') return;
    if (showMinimum(event.submitter || form)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
})();
